import _ from "lodash";
import { decorate, observable } from "mobx";

class SportyMetadataStore {
  constructor(sportyApi) {
    this.sportyApi = sportyApi;
  }

  videoCreationOptions = {};
  workflowDetails = {};

  initialize() {
    this.sportyApi.getVideoCreationOptions().then(x => {
      let videoCreationOptions = {};
      _.each(
        x.data.videoCreationOptions,
        option => (videoCreationOptions[option.name] = option.displayName)
      );
      this.videoCreationOptions = videoCreationOptions;
    });

    this.sportyApi.getWorkflowDetails().then(x => {
      let workflowDetails = {};
      _.each(
        x.data.workflowDetails,
        workflow =>
          (workflowDetails[workflow.workflowName] = workflow.description)
      );
      this.workflowDetails = workflowDetails;
    });
  }
}

decorate(SportyMetadataStore, {
  videoCreationOptions: observable,
  workflowDetails: observable
});

export default SportyMetadataStore;



// WEBPACK FOOTER //
// ./src/stores/SportyMetadataStore.js